/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SetRanaTenant
 */
export interface SetRanaTenant {
  /**
   *
   */
  ranaTenantId: string;
}

/**
 * Check if a given object implements the SetRanaTenant interface.
 */
export function instanceOfSetRanaTenant(value: object): value is SetRanaTenant {
  if (
    (!("ranaTenantId" in (value as Record<string, any>)) &&
      !("rana_tenant_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["ranaTenantId"] === undefined &&
      (value as Record<string, any>)["rana_tenant_id"] === undefined)
  )
    return false;
  return true;
}

export function SetRanaTenantFromJSON(json: any): SetRanaTenant {
  return SetRanaTenantFromJSONTyped(json, false);
}

export function SetRanaTenantFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetRanaTenant {
  if (json == null) {
    return json;
  }
  return {
    ranaTenantId: json["rana_tenant_id"],
  };
}

export function SetRanaTenantToJSON(json: any): SetRanaTenant {
  return SetRanaTenantToJSONTyped(json, false);
}

export function SetRanaTenantToJSONTyped(
  value?: SetRanaTenant | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    rana_tenant_id: value["ranaTenantId"],
  };
}
